/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import food from '../../common/images/food.png';
import favheart from '../../common/images/favorite-heart.svg';
import { ReactComponent as StarFull } from '../../common/images/star.svg';
import { ReactComponent as MotorBike } from '../../common/images/Motorbike.svg';
import { ReactComponent as Location } from '../../common/images/location-pin2.svg';
import { useDispatch, useSelector } from 'react-redux';
import qs from 'qs';
import { axiosInstance, encodeValue, sendAnalyticsPageView } from '../../utils/helper';
import { star, uniqueID } from '../../utils/constants';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { loadStoreFavorite } from '../../store/reducers/favorite';
import { FavoriteIcon, LoaderIcon, TagIcon } from '../../utils/svg';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import useNavigation from '../../hook/useNavigation';
import useNearBottom from '../../hook/useNearBottom';

const FavoriteList = () => {
	const navigate = useNavigation();
	const dispatch = useDispatch();
	const scrollRef = useRef(null);
	const storeList = useSelector((state) => state.favorite?.list || []);
	const isLoading = useSelector((state) => state.favorite.loading);
	const totalPages = useSelector((state) => state.favorite?.totalPages || 0);
	const customerID = useSelector((store) => store?.user?.customerID);

	const [open, setOpen] = useState(false);
	const contentRef = useRef(null);
	const [snapPoint, setSnapPoint] = useState(0);

	const latitude = useSelector((state) => state.user?.latitude);
	const longitude = useSelector((state) => state.user?.longitude);

	const { isNearBottom } = useNearBottom(200, scrollRef);
	const [page, setPage] = useState(1);
	const [limit] = useState(10);

  useEffect(() => {
    sendAnalyticsPageView("favorite_list_session");
  }, []);

  useEffect(() => {
    setPage(1);
    dispatch(loadStoreFavorite({ 
      page: 1, 
      limit: 10,
      uniqueID,
      latitude, 
      longitude,
      customerID
    }));
  }, [dispatch, uniqueID, latitude, longitude, customerID]);
  
	useEffect(() => {
		if (!isNearBottom || isLoading || page >= totalPages) return;
		const nextPage = page + 1;
		dispatch(loadStoreFavorite({ 
			page: nextPage, 
			limit: limit,
			isLoadMore: true,
			uniqueID,
			latitude, 
			longitude,
			customerID
		}))
			.unwrap()
			.then(() => setPage(nextPage));
	}, [isNearBottom]);

	useEffect(() => {
		if (open) {
			setTimeout(() => {
				if (contentRef.current) {
					const contentHeight = contentRef.current.getBoundingClientRect().height;
					setSnapPoint(contentHeight);
				}
			}, 0);
		}
	}, [open, storeList]);

	const handleRedirect = (url) => {
		navigate.push(url);
	};

	const onDismiss = () => {
		setOpen(false);
	};

	const removeFavourite = async (storeID) => {
		console.log('removeFavourite');
		const postObject = {
			unquieid: uniqueID,
			shopID: encodeValue(storeID),
			customerID: encodeValue(customerID),
		};
		await axiosInstance
			.post(`store/removeFavourite`, qs.stringify(postObject))
			.then((res) => {
				if (res.data.status === 'ok') {
					dispatch(loadStoreFavorite({ 
						page: page, 
						limit: limit,
						uniqueID,
						latitude, 
						longitude,
						customerID
					}));
				} else if (res.data.status === 'error') {
					console.log('Remove favorite failed', res.data.message);
				}
			})
			.catch((error) => {
				console.log('Remove favorite failed', error);
			});
	};

	return (
		<div ref={scrollRef} className='main-div h-screen overflow-y-auto scrollbar-hide'>
			<div className='flex items-center p-4 sticky top-0 z-10 bg-white border-1 border-b-1 border-solid border-gray-400'>
				<Link to={`/`} id='favorite_list_back'>
          <ArrowLeftIcon className='h-8 w-8 text-gray-900 bg-white rounded-full p-1.5' />
				</Link>
				<h2 className='text-base font-semibold ml-2'>Favorit Saya</h2>
			</div>
			<div className='content-body rel'>
				<div className='px-4'>
					{!isLoading && !storeList?.length && (
						<div className='w-full h-[60vh] flex flex-col justify-center items-center px-4'>
              <FavoriteIcon className="fill-[var(--rose-violet)] w-42 h-auto" />
							<h2 className='text-base font-semibold'>Kamu belum menambahkan resto favorit</h2>
							<p className='text-xs font-normal'>Ketuk ikon hati untuk menyimpan restoran favoritmu</p>
							<Link to='/' className='w-full mt-8'>
								<button className='button w-full !bg-[var(--rose-violet)] !border-[var(--rose-violet)]'>Jelajahi UFood</button>
							</Link>
						</div>
					)}

					<div className='outlet-listing fav-listing'>
						<ul>
							{storeList?.map((item, index) => (
								<li key={index} id={`store-${item?.storeID}`}>
									<div className='flex' style={{ gap: '11px', marginBottom: '26px' }}>
										<a onClick={() => handleRedirect(`/outlet/${item?.storeSlug}/delivery`)}>
											<div style={{ height: '95px', width: '95px' }}>
												<img
													style={{
														minWidth: '95px',
														minHeight: '95px',
														objectFit: 'cover',
														objectPosition: 'center',
														borderRadius: '8px',
													}}
													src={item?.storeImage || food}
													alt={item?.storeName}
												/>
											</div>
										</a>
										<div className='w-full'>
											<a onClick={() => handleRedirect(`/outlet/${item?.storeSlug}/delivery`)}>
												<h3 className='text-sm font-semibold'>{item?.storeName}</h3>
												<div className='flex gap-1 pt-1'>
													<StarFull width={17} height={17} color={star} />
													<h5 className='text-xs font-normal'>
														{item?.rating || 0} ({item?.totalRating || 0})
													</h5>
												</div>
												<div className='flex gap-1 pt-1'>
													<MotorBike width={17} height={17} />
													<h5 className='text-xs font-normal'>
														{parseFloat(item?.distance || 0).toFixed(2)} km
													</h5>
												</div>
												{item?.offerInfo && (
													<h6 className='flex gap-1 items-center pt-1'>
                            <TagIcon className="h-4.5 w-4.5 fill-[var(--rose-violet)]" />
														{item?.offerInfo && <div className='text-xs font-medium'>{item?.offerInfo}</div>}
													</h6>
												)}
											</a>
										</div>
									</div>
									<div onClick={() => removeFavourite(item.storeID)} className='add-fav'>
										<img src={favheart} alt='Heart' />
									</div>
								</li>
							))}
							{isLoading && (
								<div className='flex justify-center !mt-1'>
									<LoaderIcon />
								</div>
							)}
						</ul>
					</div>
				</div>
			</div>
			<BottomSheet
				open={open}
				onDismiss={onDismiss}
				defaultSnap={({ maxHeight }) => maxHeight / 2}
				snapPoints={({ maxHeight }) => Math.min(snapPoint, maxHeight - maxHeight / 7)}
				header={<h3 className='flex items-start text-base font-semibold py-3'>Daftar outlet</h3>}
			>
				<div ref={contentRef} className='px-4' style={{ marginTop: '12px' }}>
					<ul>
						{storeList?.map((item, index) => (
							<li key={index} className='mb-4'>
								<a onClick={() => handleRedirect(`/outlet/${item?.storeSlug}/delivery`)}>
									<div className='flex' style={{ gap: '12px' }}>
										<img
											src={item?.storeImage || food}
											alt={item?.storeName}
											style={{
												width: '24px',
												height: '24px',
												objectFit: 'cover',
												borderRadius: '2px',
											}}
										/>
										<div style={{ maxWidth: 'calc(100% - 36px)', marginBottom: '14px' }}>
											<h4 className='text-sm font-semibold'>{item?.storeName}</h4>
											<div className='flex gap-1'>
												<Location width={14} height={14} />
												<p className='text-xs font-normal'>{parseFloat(item?.distance || 0).toFixed(2)} km away</p>
											</div>
										</div>
									</div>
								</a>
							</li>
						))}
					</ul>
				</div>
			</BottomSheet>
		</div>
	);
};

export default FavoriteList;
